import { render, staticRenderFns } from "./EditStudentMsg.vue?vue&type=template&id=5364c38a&scoped=true&"
import script from "./EditStudentMsg.vue?vue&type=script&lang=js&"
export * from "./EditStudentMsg.vue?vue&type=script&lang=js&"
import style0 from "./EditStudentMsg.vue?vue&type=style&index=0&id=5364c38a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364c38a",
  null
  
)

export default component.exports